/* eslint-disable no-unused-expressions */
import React from 'react';
import {connect} from 'react-redux';
import './CreateBlock.css';
//import 'react-toastify/dist/ReactToastify.css';
import * as PropertyBucket from '../../Properties/Properties.js';
import * as actionsBlock from '../../Redux/Actions/Blocks';
import * as httpService from '../HttpService/HttpService';
import {BlockDto} from '../Dtos/BlockDto';
import PopUp from '.././PopUp/PopUp';
import {BlockForm} from './BlockForm';


class CreateBlock extends React.Component {

	constructor(props, size) {
		super(props);
		this.state = {
			violations: [],
			code: '',
			name: '',
			showPopup: false,
			popUp: {title: null, notification: null},
			answerClassesCode: [],
			answerClassesName: [],
			isChangeRoutePossible: true
		};
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
	}

	componentDidMount() {
		document.title = "e-Kontrole | Utwórz blok";
	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}


	handleSaveBlock = ({values, resetForm}) => {
		let _this = this;

		let blockDto = new BlockDto();
		blockDto.name = values.name;
		blockDto.active = true;

		let url = PropertyBucket.urlAddBlock();
		let callPromise = httpService.getServiceWithSupportErrors(url, 'POST', blockDto);

		callPromise.then(
			function (message) {
				if (message.violations) {
					_this.setState({
						violations: message.violations,
					})
				} else {
					_this.setState({
						violations: [],
						name: message.name,
						code: message.blockId,
						isChangeRoutePossible: true,
						showPopup: true,
						popUp: { 
							title: 'Komunikat', 
							notification: PropertyBucket.getCreateBlockMessage(), 
							type: 'notify', 
							onClickEvent: () => _this.props.history.push('/search_block')
						}
					})
				}
			},
			function (error) {
				_this.setState({
					showPopup: true,
					popUp: {title: 'Błąd', notification: error, type: 'error'}
				})
			}
		)

	};

	render() {
		let popUp;
		this.state.showPopup ?
			popUp = <PopUp 
						type={this.state.popUp.type}
						title={this.state.popUp.title}
						notification={this.state.popUp.notification}
						link={this.state.popUp.link ? this.state.popUp.link : null} // cannot be undefined because of PopUp.js implementation
						onClickEvent={this.state.popUp.onClickEvent}
						closePopUp={this.handleClosePopUp}
			/> : null;

		return <div id='block_create'>
			{popUp}
			<h2 className='mb-3'>Utwórz blok</h2>
			<BlockForm 
				handleSaveBlock={this.handleSaveBlock} 
				code={Number(this.state.code)} 
				violations={this.state.violations}
				name={this.state.name} />
		</div>
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {fetchBlocksData: () => dispatch(actionsBlock.getData())}
};

export const CreateBlockProvider = connect(mapStateToProps, mapDispatchToProps)(CreateBlock);

